import KunLoading100 from './src/index'

KunLoading100.install = function (Vue) {
	Vue.component(KunLoading100.name, KunLoading100);
}

export default KunLoading100;
